import React from 'react';
import styles from 'routes/vendorRe/pages/VendorCctv.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import { 
    commonBgColor, 
    commonBodyPadding, 
    commonH1Padding, 
    commonH1Size, 
    contentCenter, 
    contentEnd, 
    contentStart,
    infoFontSize1,
    infoFontSize2,
    
} from 'routes/vendorRe/constraint/constraints';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import 'routes/vendorRe/pages/VendorCctv.css';
import pause from 'routes/vendorRe/images/pause.png';
import MonthSelect from 'routes/vendorRe/components/MonthSelect';
import DaySelect from 'routes/vendorRe/components/DaySelect';
import HourSelect from 'routes/vendorRe/components/HourSelect';
import VendorCctvList from 'routes/vendorRe/components/VendorCctvList';

const VendorCctv = () => {
    return (
        <Container backgroundColor={commonBgColor} height="140vh">
            <div style={{height: "10vh"}}></div>
            <VerticalFlex>
                <FlexChild flex="1" padding={commonBodyPadding} alignItems={contentStart}>
                    <P padding={commonH1Padding} size={commonH1Size}>매장기기 관리</P>
                    <VerticalFlex backgroundColor="white" borderRadius="1em" padding="24px">
                        <FlexChild flex="1" justifyContent={contentCenter}>
                            <P size={infoFontSize1}>푸푸 관저점 CCTV</P>
                            <VerticalFlex>
                                <FlexChild justifyContent={contentCenter} alignItems={contentStart}>
                                    <P size={infoFontSize2} color="#D2D2D2">* 화면을 눌러 크게 볼 수 있습니다.</P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild flex="7">
                            <VerticalFlex>
                                <FlexChild flex="5">
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <div className={styles.noSignal}>신호없음</div>
                                        </FlexChild>
                                        <FlexChild>
                                            <div className={styles.noSignal}>신호없음</div>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild flex="5">
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <div className={styles.noSignal}>신호없음</div>
                                        </FlexChild>
                                        <FlexChild>
                                            <div className={styles.noSignal}>신호없음</div>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild flex="1" justifyContent={contentCenter}>
                                    {/* 
                                        https://www.npmjs.com/package/react-range-slider-input
                                    */}
                                    <RangeSlider
                                        className={"single-thumb"}
                                        defaultValue={[0, 100]}
                                        thumbsDisabled={[true, false]}
                                        rangeSlideDisabled={true}
                                    />
                                </FlexChild>
                                <FlexChild flex="1">
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <div className={styles.cctvControlBtn}>
                                                <VerticalFlex>
                                                    <FlexChild justifyContent={contentCenter} alignItems={contentCenter}>
                                                        10분 전
                                                    </FlexChild>
                                                </VerticalFlex>
                                            </div>
                                        </FlexChild>
                                        <FlexChild justifyContent={contentCenter}>
                                            <img className={styles.pause} src={pause} alt='일시 정지' />
                                        </FlexChild>
                                        <FlexChild justifyContent={contentEnd}>
                                            <div className={styles.cctvControlBtn}>
                                                <VerticalFlex>
                                                    <FlexChild justifyContent={contentCenter} alignItems={contentCenter}>
                                                        10분 후
                                                    </FlexChild>
                                                </VerticalFlex>
                                            </div>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild flex="7" alignItems={contentStart}>
                            <P size={infoFontSize1} padding="1em 0">지난 영상 다시보기</P>
                            <VerticalFlex>
                                <FlexChild flex="1" padding="0 0 24px">
                                    <HorizontalFlex gap="1em">
                                        <FlexChild gap="1em">
                                            <MonthSelect /> 월
                                        </FlexChild>
                                        <FlexChild gap="1em">
                                            <DaySelect /> 일
                                        </FlexChild>
                                        <FlexChild gap="1em">
                                            <HourSelect /> 시
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild flex="11">
                                    {/* 스크롤 영역 */}
                                    <div className={styles.scroll}>
                                        <VerticalFlex height="auto">
                                            {/* 반복 구간 시작 */}
                                            <VendorCctvList />
                                            <VendorCctvList />
                                            <VendorCctvList />
                                            <VendorCctvList />
                                            <VendorCctvList />
                                            {/* 반복 구간 끝 */}
                                        </VerticalFlex>
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VendorCctv;